import React from "react";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { identifyClarityUser } from "./utils/clarityIdentify";

export const msalInstance = new PublicClientApplication(msalConfig);
// ログイン直後はページ遷移が起きないため、ここでも Clarity に紐付ける
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    identifyClarityUser(event.payload?.account);
  }
});

const wrapWithProvider = ({ element }) => {
  return <MsalProvider instance={msalInstance}>{element}</MsalProvider>;
};

export default wrapWithProvider;
